/** @jsxImportSource @emotion/react */

import { Button } from '@shared/react-ui-core';
import { useTranslation } from 'react-i18next';

const NavCta = () => {
  const { t } = useTranslation('common');
  return (
    <Button
      variant="container"
      color="purple"
      href="/quiz"
      className="h-cove-50 w-max shrink-0"
    >
      {t('build-my-system', { defaultValue: 'Build My System' })}
    </Button>
  );
};

export default NavCta;
